import { fromEvent } from 'rxjs';
import getHousingType from '../services/housingTypeService';

const container = document.querySelector('[data-housing-select]');
const selectChange$ = fromEvent(container, 'change');
const housingElements = [...container.querySelectorAll('[data-housing-type]')];
const housingTypeOptions = getHousingType(housingElements);

/**
 * Handles when the housing type select dropdown changes.
 */
selectChange$.subscribe((event) => {
  const selectElement = event.target;
  const housingType = selectElement.value;
  const housingOption = housingTypeOptions[housingType];
  housingOption.dispatchFetchResultAction();  
});
